import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../UI/card';
import { Avatar, AvatarFallback, AvatarImage } from '../UI/avatar';

const RecentConnectionsCard = ({ connections = [] }) => {
  const getInitials = (person) => {
    if (!person) return 'U';
    const firstName = person.firstName || person.name?.split(' ')[0] || '';
    const lastName = person.lastName || person.name?.split(' ')[1] || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U';
  };

  const getTimeAgo = (date) => {
    if (!date) return 'Recently';
    const now = new Date();
    const connectionDate = new Date(date);
    const diffInMs = now - connectionDate;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return 'Today';
    if (diffInDays === 1) return '1 day ago';
    if (diffInDays < 7) return `${diffInDays} days ago`;
    if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} week${Math.floor(diffInDays / 7) > 1 ? 's' : ''} ago`;
    return `${Math.floor(diffInDays / 30)} month${Math.floor(diffInDays / 30) > 1 ? 's' : ''} ago`;
  };

  const avatarColors = [
    'bg-blue-600',
    'bg-green-600',
    'bg-purple-600',
    'bg-orange-600',
    'bg-pink-600'
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Recent Connections</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {connections.length > 0 ? (
          connections.slice(0, 5).map((connection, index) => (
            <div key={connection._id || index} className="flex items-center gap-3">
              <Avatar className="h-8 w-8">
                <AvatarImage src={connection.profileImage} alt={connection.name || 'User'} />
                <AvatarFallback className={`${avatarColors[index % avatarColors.length]} text-white text-xs`}>
                  {getInitials(connection)}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  {connection.name || `${connection.firstName} ${connection.lastName}` || 'User'}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {getTimeAgo(connection.connectedAt || connection.createdAt)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-4">
            <p className="text-sm text-gray-500 dark:text-gray-400">No recent connections yet</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentConnectionsCard;
